// extracted by mini-css-extract-plugin
module.exports = {"link":"ProductImageLink_link__WVx58","image":"ProductImageLink_image__PZaKx","unavailable":"ProductImageLink_unavailable__Fjmr_","outOfStock":"ProductImageLink_outOfStock__VOIYX"};